import React from 'react';
import AttachmentItem, { UploadProgress } from '../AttachmentItem/AttachmentsItem';
import './AttachmentsContainer.scss';

export type AttachmentItemType = {
  id: number;
  type: string;
  name: string;
  processing?: UploadProgress;
  file?: File | null;
  onRemove?: (name: string) => void;
};

type AttachmentContainerProps = {
  attachments: AttachmentItemType[];
  removeFile: (fileId: number) => void;
};

export default function AttachmentsContainer({ attachments, removeFile }: AttachmentContainerProps) {
  return (
    <div className="attachment-list-container">
      <div className="attachment-list-container-list">
        {attachments.map((file, index: number) => (
          <React.Fragment key={file.id}>
            <AttachmentItem attachment={file} onRemove={removeFile} />
            {index < attachments.length - 1 && <div className="attachment-list-container-list-divider-line"></div>}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
